import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { isDefined } from '@trimble-gcs/common';
import { filter, map, Observable, of, switchMap } from 'rxjs';
import { GET_SCAN_PROJECT_URL } from '../utils/get-scan-project-url';
import { SetClassifiers } from './classifier.actions';
import { Classifier } from './classifier.model';
import { ClassifierState } from './classifier.state';

@Injectable({
  providedIn: 'root',
})
export class ClassifierService {
  private readonly getScanProjectUrl$ = inject(GET_SCAN_PROJECT_URL);
  private readonly store = inject(Store);
  private readonly http = inject(HttpClient);

  getClassifiers() {
    return this.store
      .selectOnce(ClassifierState.classifiers)
      .pipe(
        switchMap((classifiers) =>
          isDefined(classifiers) ? of(classifiers) : this.fetchAndCacheClassifiers(),
        ),
      );
  }

  private fetchAndCacheClassifiers(): Observable<Classifier[]> {
    return this.getScanProjectUrl$(`/classifiers`).pipe(
      filter(isDefined),
      switchMap((url) => this.http.get<Classifier[]>(url)),
      switchMap((classifiers) =>
        this.store.dispatch(new SetClassifiers(classifiers)).pipe(map(() => classifiers)),
      ),
    );
  }
}
